import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { EmployeeSelect } from 'components/common/select/EmployeeSelectField';
import { makeEmployeeIdLoader } from 'helpers/debounce';

/**
 * AssigneeSelect — the single-person picker for activities and tasks.
 *
 * A thin adapter over the shared `EmployeeSelect` (avatar + code + full name +
 * email): it keeps this component's object contract, `{ id, name, email }`, which
 * is what the activity/task forms store, while the picker itself deals in options.
 */
const AssigneeSelect = ({ label, value, onChange, placeholder = 'Search employee...' }) => {
  // One debounced loader per instance; option.value is the employee id, matching
  // the `id` these forms persist.
  const loadOptions = useMemo(() => makeEmployeeIdLoader(), []);

  const selected = value
    ? { value: value.id, label: value.name, email: value.email, avatarUrl: value.avatarUrl }
    : null;

  const handleChange = (option) => onChange(
    option
      ? { id: option.value, name: option.label, email: option.email, avatarUrl: option.avatarUrl || null }
      : null
  );

  return (
    <EmployeeSelect
      label={label}
      value={selected}
      onChange={handleChange}
      loadOptions={loadOptions}
      placeholder={placeholder}
    />
  );
};

AssigneeSelect.propTypes = {
  label:       PropTypes.string,
  value:       PropTypes.shape({
    id: PropTypes.any, name: PropTypes.string, email: PropTypes.string, avatarUrl: PropTypes.string,
  }),
  onChange:    PropTypes.func.isRequired,
  placeholder: PropTypes.string,
};

export default AssigneeSelect;
